module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://shadow.zhaogangimg.com/assets/zgkaihu/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 156);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 102:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.symbol");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.keys");

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.to-string");

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.filter");

/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "core-js/modules/es.function.name"
var es_function_name_ = __webpack_require__(3);

// EXTERNAL MODULE: external "core-js/modules/es.symbol"
var es_symbol_ = __webpack_require__(12);

// EXTERNAL MODULE: external "core-js/modules/es.symbol.description"
var es_symbol_description_ = __webpack_require__(22);

// EXTERNAL MODULE: external "core-js/modules/es.symbol.iterator"
var es_symbol_iterator_ = __webpack_require__(23);

// EXTERNAL MODULE: external "core-js/modules/es.array.concat"
var es_array_concat_ = __webpack_require__(36);

// EXTERNAL MODULE: external "core-js/modules/es.array.filter"
var es_array_filter_ = __webpack_require__(15);

// EXTERNAL MODULE: external "core-js/modules/es.array.find"
var es_array_find_ = __webpack_require__(30);

// EXTERNAL MODULE: external "core-js/modules/es.array.for-each"
var es_array_for_each_ = __webpack_require__(8);

// EXTERNAL MODULE: external "core-js/modules/es.array.from"
var es_array_from_ = __webpack_require__(24);

// EXTERNAL MODULE: external "core-js/modules/es.array.includes"
var es_array_includes_ = __webpack_require__(49);

// EXTERNAL MODULE: external "core-js/modules/es.array.iterator"
var es_array_iterator_ = __webpack_require__(16);

// EXTERNAL MODULE: external "core-js/modules/es.array.map"
var es_array_map_ = __webpack_require__(28);

// EXTERNAL MODULE: external "core-js/modules/es.array.slice"
var es_array_slice_ = __webpack_require__(17);

// EXTERNAL MODULE: external "core-js/modules/es.object.get-own-property-descriptor"
var es_object_get_own_property_descriptor_ = __webpack_require__(26);

// EXTERNAL MODULE: external "core-js/modules/es.object.get-own-property-descriptors"
var es_object_get_own_property_descriptors_ = __webpack_require__(27);

// EXTERNAL MODULE: external "core-js/modules/es.object.keys"
var es_object_keys_ = __webpack_require__(13);

// EXTERNAL MODULE: external "core-js/modules/es.object.to-string"
var es_object_to_string_ = __webpack_require__(14);

// EXTERNAL MODULE: external "core-js/modules/es.regexp.to-string"
var es_regexp_to_string_ = __webpack_require__(20);

// EXTERNAL MODULE: external "core-js/modules/es.string.includes"
var es_string_includes_ = __webpack_require__(51);

// EXTERNAL MODULE: external "core-js/modules/es.string.iterator"
var es_string_iterator_ = __webpack_require__(18);

// EXTERNAL MODULE: external "core-js/modules/es.string.trim"
var es_string_trim_ = __webpack_require__(44);

// EXTERNAL MODULE: external "core-js/modules/web.dom-collections.for-each"
var web_dom_collections_for_each_ = __webpack_require__(9);

// EXTERNAL MODULE: external "core-js/modules/web.dom-collections.iterator"
var web_dom_collections_iterator_ = __webpack_require__(19);

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(2);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// EXTERNAL MODULE: external "zgkaihu/lib/module-title"
var module_title_ = __webpack_require__(53);
var module_title_default = /*#__PURE__*/__webpack_require__.n(module_title_);

// EXTERNAL MODULE: external "zgkaihu/lib/address"
var address_ = __webpack_require__(74);
var address_default = /*#__PURE__*/__webpack_require__.n(address_);

// EXTERNAL MODULE: external "zgkaihu/lib/upload"
var upload_ = __webpack_require__(75);
var upload_default = /*#__PURE__*/__webpack_require__.n(upload_);

// EXTERNAL MODULE: external "zgkaihu/lib/date-rang"
var date_rang_ = __webpack_require__(54);
var date_rang_default = /*#__PURE__*/__webpack_require__.n(date_rang_);

// EXTERNAL MODULE: external "zgkaihu/lib/bank"
var bank_ = __webpack_require__(76);
var bank_default = /*#__PURE__*/__webpack_require__.n(bank_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/main.vue?vue&type=script&lang=js&

























var _components;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var TYPE = {
  input: 'input',
  dateRang: 'dateRang',
  upload: 'upload',
  title: 'title',
  display: 'display',
  tips: 'tips',
  radio: 'radio',
  bank: 'bank',
  address: 'address',
  date: 'date',
  select: 'select'
};





/* harmony default export */ var mainvue_type_script_lang_js_ = ({
  name: 'ZgKhForm',
  components: (_components = {}, defineProperty_default()(_components, module_title_default.a.name, module_title_default.a), defineProperty_default()(_components, upload_default.a.name, upload_default.a), defineProperty_default()(_components, date_rang_default.a.name, date_rang_default.a), defineProperty_default()(_components, address_default.a.name, address_default.a), defineProperty_default()(_components, bank_default.a.name, bank_default.a), _components),
  props: {
    viewData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    labelWidth: {
      type: String,
      default: '268px'
    },
    contentWidth: {
      type: String,
      default: '360px'
    }
  },
  data: function data() {
    return {
      model: {}
    };
  },
  watch: {
    viewData: {
      handler: 'initViewData',
      immediate: true
    }
  },
  methods: {
    initViewData: function initViewData(newV, oldV) {
      var _this = this;

      this.viewData.forEach(function (ele) {
        if (ele.type !== TYPE.upload) {
          if (ele.key) {
            _this.$set(_this.model, ele.key, ele.value);
          }
        }
      });
    },
    //表单校验
    validate: function validate() {
      var success = true;

      var _iterator = _createForOfIteratorHelper(this.viewData),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (!item.rules) {
            continue;
          }

          if ([TYPE.input, TYPE.radio, TYPE.dateRang, TYPE.address, TYPE.display, TYPE.date, TYPE.select].includes(item.type)) {
            success = this.validateForm(item);
          } else if (item.type === TYPE.upload) {
            success = this.validateUpload(item);
          } else if (item.type === TYPE.bank) {
            success = this.validateBank(item);
          }

          if (!success) {
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return success;
    },
    validateForm: function validateForm(item) {
      var _this2 = this;

      var success = true;
      this.$refs.form.validateField(item.key, function (errorMsg) {
        if (errorMsg) {
          _this2.$message.error(errorMsg);

          success = false;
        }
      });
      return success;
    },
    validateDateRang: function validateDateRang(item) {
      var _item$value = item.value,
          start = _item$value.start,
          end = _item$value.end,
          long = _item$value.long;

      if (start && end || start && long) {
        return true;
      }

      this.$message.error("\u8BF7\u9009\u62E9".concat(item.label));
      return false;
    },
    validateUpload: function validateUpload(item) {
      var success = true;

      if (item.datas) {
        var _iterator2 = _createForOfIteratorHelper(item.datas),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var child = _step2.value;
            success = !!child.value.fk;

            if (!success) {
              this.$message.error("\u8BF7\u4E0A\u4F20".concat(item.label || '').concat(child.config.label || ''));
              break;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } else {
        success = item.value.fk;

        if (!success) {
          this.$message.error("\u8BF7\u4E0A\u4F20".concat(item.config.label));
        }
      }

      return success;
    },
    validateBank: function validateBank(item) {
      return this.$refs[item.key].validate();
    },
    //主要是为了同步数组元素的value和model对应的value保持一直。
    setValue: function setValue(type, key, value) {
      if (type === TYPE.address) {
        this.setAddressValue(key, value);
      } else if (type === TYPE.bank) {
        this.setBankValue(key, value);
      } else if (type === TYPE.upload) {
        this.setUploadValue(key, value);
      } else {
        this.model[key] = value;
        var ele = this.viewData.find(function (ele) {
          return ele.key === key;
        });

        if (ele) {
          ele.value = value;
        }
      }
    },
    setModelValue: function setModelValue(key, value) {
      this.model[key] = value;
    },
    setAddressValue: function setAddressValue(key, value) {
      this.$refs[key].setValue(value);
    },
    setBankValue: function setBankValue(key, value) {
      this.$refs[key].setValue(value);
    },
    setUploadValue: function setUploadValue(key, value) {
      var _iterator3 = _createForOfIteratorHelper(this.viewData),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;

          if (item.type === TYPE.upload) {
            if (item.datas) {
              var child = item.datas.find(function (ele) {
                return ele.key === key;
              });

              if (child) {
                child.value = value;
              }
            } else {
              if (item.key === key) {
                item.value = value;
                break;
              }
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    },
    clearValidate: function clearValidate(key) {
      this.$refs.form.clearValidate(key);
    },
    clearAddress: function clearAddress(ref) {
      this.$refs[ref].clearAddress();
    },
    clearBank: function clearBank(ref) {
      this.$refs[ref].clearBank();
    },
    clearInput: function clearInput(key) {
      this.model[key] = '';
      var ele = this.viewData.find(function (ele) {
        return ele.key === key;
      });

      if (ele) {
        ele.value = '';
      }
    },
    //处理事件
    handleInput: function handleInput(v, ele) {
      v = v.trim();
      ele.value = v;
      this.model[ele.key] = v;
      this.$emit('input', ele);
    },
    handleRadioChange: function handleRadioChange(v, ele) {
      ele.value = v;
      this.model[ele.key] = v;
      this.$emit('radioChange', ele);
    },
    handleSelectChange: function handleSelectChange(v, ele) {
      ele.value = v;
      this.model[ele.key] = v;
      this.$emit('selectChange', ele);
    },
    handleDateRangChange: function handleDateRangChange(field, ele) {
      this.$emit('dateRangChange', _objectSpread({}, field, {
        ele: ele
      }));
    },
    handleUploadChange: function handleUploadChange(v, ele, item) {
      this.$emit('uploadChange', {
        value: v,
        ele: ele,
        item: item
      });
    },
    handleBankChange: function handleBankChange(v, ele) {
      this.$emit('bankChange', _objectSpread({}, v, {
        ele: ele
      }));
    },
    handleDateChange: function handleDateChange(v, ele) {
      ele.value.date = v;
      ele.value.long = false;
      this.$emit('dateChange', {
        value: v,
        ele: ele
      });
    },
    handleDateCheckboxChange: function handleDateCheckboxChange(v, ele) {
      ele.value.long = v;
      ele.value.date = '';
      this.$emit('dateChange', {
        value: v,
        ele: ele
      });
    },
    //渲染元素
    getElementTips: function getElementTips(ele) {
      var h = this.$createElement;
      return h("div", {
        "class": ['zg-kh-form-tips', ele.itemClass],
        style: ele.itemStyle
      }, [h("img", {
        "class": "zg-kh-form-tips-icon",
        attrs: {
          src: __webpack_require__(56)
        }
      }), h("span", {
        "class": "zg-kh-form-tips-content"
      }, [ele.title])]);
    },
    getElementDisplay: function getElementDisplay(ele) {
      var h = this.$createElement;
      return h("el-form-item", {
        "class": ['zg-kh-form-item-display', ele.itemClass],
        style: ele.itemStyle,
        attrs: {
          prop: ele.key,
          label: ele.label,
          rules: ele.rules
        }
      }, [h("div", [ele.value])]);
    },
    getElementInput: function getElementInput(ele) {
      var _this3 = this;

      var h = this.$createElement;
      var tips = null;

      if (ele.tips) {
        tips = h("template", {
          slot: "label"
        }, [h("span", [ele.label]), h("el-popover", {
          attrs: {
            "popper-class": "zg-kh-form-label-tips-popover",
            effect: "dark",
            trigger: "hover",
            "append-to-body": false,
            content: ele.tips,
            placement: "right",
            "popper-options": {
              modifiersIgnored: ['preventOverflow', 'flip']
            }
          }
        }, [h("img", {
          slot: "reference",
          "class": "zg-kh-form-label-tips",
          attrs: {
            src: __webpack_require__(102)
          }
        })])]);
      }

      return h("el-form-item", {
        "class": ['zg-kh-form-input', ele.itemClass],
        style: ele.itemStyle,
        attrs: {
          label: ele.label,
          prop: ele.key,
          rules: ele.rules
        }
      }, [h("el-input", {
        style: {
          width: this.contentWidth
        },
        attrs: {
          value: ele.value,
          placeholder: ele.placeholder || "\u8BF7\u8F93\u5165".concat(ele.label),
          maxlength: ele.maxlength
        },
        on: {
          "input": function input(v) {
            return _this3.handleInput(v, ele);
          }
        }
      }), tips]);
    },
    getElementDate: function getElementDate(ele) {
      var _this4 = this;

      var h = this.$createElement;
      return h("el-form-item", {
        "class": ['zg-kh-form-date', ele.itemClass],
        style: ele.itemStyle,
        attrs: {
          label: ele.label,
          prop: ele.key,
          rules: ele.rules
        }
      }, [h("el-date-picker", {
        attrs: {
          value: ele.value.date,
          type: "date",
          placeholder: ele.value.long ? '长期' : ele.placeholder ? ele.placeholder : '请选择日期',
          "value-format": "yyyy-MM-dd",
          editable: false,
          clearable: false,
          "picker-options": ele.pickerOptions
        },
        "class": ['zg-kh-form-date-picker', ele.longTerm && ele.value.long ? 'is-long' : ''],
        on: {
          "input": function input(v) {
            return _this4.handleDateChange(v, ele);
          }
        }
      }), ele.longTerm ? h("span", [h("el-checkbox", {
        attrs: {
          value: ele.value.long
        },
        "class": "m-l12",
        on: {
          "change": function change(v) {
            return _this4.handleDateCheckboxChange(v, ele);
          }
        }
      }), h("span", {
        "class": "zg-kh-form-date-long"
      }, ["\u957F\u671F\u6709\u6548"])]) : null]);
    },
    getElementDateRang: function getElementDateRang(ele) {
      var _this5 = this;

      var h = this.$createElement;
      return h("el-form-item", {
        "class": ['zg-kh-form-daterang', ele.itemClass],
        style: ele.itemStyle,
        attrs: {
          label: ele.label,
          prop: ele.key,
          rules: ele.rules
        }
      }, [h("zg-kh-date-rang", {
        on: {
          "change": function change(v) {
            return _this5.handleDateRangChange(v, ele);
          }
        },
        attrs: {
          data: ele.value,
          "long-term": ele.long,
          "picker-options": ele.pickerOptions
        }
      })]);
    },
    getElementUpload: function getElementUpload(ele) {
      var _this6 = this;

      var h = this.$createElement;
      var upload = null;

      if (ele.datas) {
        upload = ele.datas.map(function (item, index) {
          return h("zg-kh-upload", {
            "class": [index === 0 ? 'm-t11' : 'm-t16'],
            attrs: {
              data: item.value,
              example: item.example,
              template: item.template,
              tips: item.tips,
              config: item.config,
              disabled: item.disabled
            },
            on: {
              "change": function change(v) {
                return _this6.handleUploadChange(v, ele, item);
              }
            }
          });
        });
      } else {
        upload = h("zg-kh-upload", {
          "class": "m-t11",
          attrs: {
            data: ele.value,
            example: ele.example,
            template: ele.template,
            tips: ele.tips,
            config: ele.config,
            disabled: ele.disabled
          },
          on: {
            "change": function change(v) {
              return _this6.handleUploadChange(v, ele);
            }
          }
        });
      }

      return h("el-form-item", {
        "class": ['zg-kh-form-upload', ele.itemClass],
        style: ele.itemStyle,
        attrs: {
          label: ele.label,
          prop: ele.key,
          rules: ele.rules
        }
      }, [upload]);
    },
    getElementRadio: function getElementRadio(ele) {
      var _this7 = this;

      var h = this.$createElement;
      var radio = ele.options.map(function (item) {
        return h("el-radio", {
          attrs: {
            label: item.value
          }
        }, [item.lable]);
      });
      return h("el-form-item", {
        "class": ['zg-kh-form-item-radio', ele.itemClass],
        style: ele.itemStyle,
        attrs: {
          label: ele.label,
          prop: ele.key,
          rules: ele.rules
        }
      }, [h("el-radio-group", {
        attrs: {
          value: ele.value
        },
        on: {
          "input": function input(v) {
            return _this7.handleRadioChange(v, ele);
          }
        }
      }, [radio])]);
    },
    getElementselect: function getElementselect(ele) {
      var _this8 = this;

      var h = this.$createElement;
      return h("el-form-item", {
        "class": ['zg-kh-form-item-input', ele.itemClass],
        style: ele.itemStyle,
        attrs: {
          label: ele.label,
          prop: ele.key,
          rules: ele.rules
        }
      }, [h("el-select", {
        attrs: {
          value: ele.value
        },
        on: {
          "change": function change(v) {
            return _this8.handleSelectChange(v, ele);
          }
        }
      }, [ele.options.map(function (item) {
        return h("el-option", {
          key: item.value,
          attrs: {
            value: item.value,
            label: item.label
          }
        });
      })])]);
    },
    getElementBank: function getElementBank(ele) {
      var _this9 = this;

      var h = this.$createElement;
      return h("zg-kh-bank", {
        ref: ele.key,
        attrs: {
          required: ele.required,
          value: ele.value,
          contentWidth: this.contentWidth,
          channelCode: ele.channelCode
        },
        on: {
          "change": function change(v) {
            return _this9.handleBankChange(v, ele);
          }
        }
      });
    },
    getElementAddress: function getElementAddress(ele) {
      var h = this.$createElement;
      return h("el-form-item", {
        "class": ['zg-kh-form-address', ele.itemClass],
        style: ele.itemStyle,
        attrs: {
          label: ele.label,
          prop: ele.key,
          rules: ele.rules
        }
      }, [h("zg-kh-address", {
        ref: ele.key,
        attrs: {
          value: ele.value,
          placeholder: ele.placeholder,
          maxLevel: ele.maxLevel,
          contentWidth: this.contentWidth
        }
      })]);
    }
  },
  render: function render() {
    var _this10 = this;

    var h = arguments[0];
    var lists = this.viewData.map(function (ele) {
      switch (ele.type) {
        case TYPE.title:
          return h("zg-kh-module-title", {
            attrs: {
              title: ele.title
            }
          });

        case TYPE.tips:
          return _this10.getElementTips(ele);

        case TYPE.display:
          return _this10.getElementDisplay(ele);

        case TYPE.input:
          return _this10.getElementInput(ele);

        case TYPE.dateRang:
          return _this10.getElementDateRang(ele);

        case TYPE.upload:
          return _this10.getElementUpload(ele);

        case TYPE.radio:
          return _this10.getElementRadio(ele);

        case TYPE.bank:
          return _this10.getElementBank(ele);

        case TYPE.address:
          return _this10.getElementAddress(ele);

        case TYPE.date:
          return _this10.getElementDate(ele);

        case TYPE.select:
          return _this10.getElementselect(ele);
      }
    });
    return h("el-form", {
      "class": "zg-kh-form",
      ref: "form",
      attrs: {
        "label-width": this.labelWidth,
        model: this.model
      }
    }, [lists]);
  }
});
// CONCATENATED MODULE: ./packages/form/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/form/src/main.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_mainvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/form/src/main.vue"
/* harmony default export */ var main = (component.exports);
// CONCATENATED MODULE: ./packages/form/index.js


/* istanbul ignore next */

main.install = function (Vue) {
  Vue.component(main.name, main);
};

/* harmony default export */ var packages_form = __webpack_exports__["default"] = (main);

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.iterator");

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.slice");

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.iterator");

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/web.dom-collections.iterator");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.regexp.to-string");

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.symbol.description");

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.symbol.iterator");

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.from");

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.get-own-property-descriptor");

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.get-own-property-descriptors");

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.map");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.function.name");

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.find");

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.concat");

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.trim");

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.includes");

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.includes");

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

module.exports = require("zgkaihu/lib/module-title");

/***/ }),

/***/ 54:
/***/ (function(module, exports) {

module.exports = require("zgkaihu/lib/date-rang");

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

module.exports = require("zgkaihu/lib/address");

/***/ }),

/***/ 75:
/***/ (function(module, exports) {

module.exports = require("zgkaihu/lib/upload");

/***/ }),

/***/ 76:
/***/ (function(module, exports) {

module.exports = require("zgkaihu/lib/bank");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.for-each");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/web.dom-collections.for-each");

/***/ })

/******/ });